import '@babel/polyfill';import 'uni-pages';import 'uni-h5';import Vue from 'vue'
import App from '@/App'
import store from '@/store'
import jWeixin  from 'wecomjsdk'
import moment from 'moment'

import "./common/utils/pc";


Vue.config.productionTip = false
Vue.prototype.$store = store
Vue.prototype.jWeixin = jWeixin
Vue.filter('dateFormat',date=>{
  return moment(date).format('YYYY-MM-DD hh:mm:ss')
})
Vue.prototype.$prompt = (params = {}) =>
  store.commit('toast/setOptions', {
    type: 'prompt',
    visible: true,
    ...params
  })
Vue.prototype.$popup = (params = {}) =>
  store.commit('toast/setOptions', {
    type: 'popup',
    visible: true,
    ...params
  })
App.mpType = 'app'

const app = new Vue({
  ...App
})
app.$mount()